import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLaptopCode, faNetworkWired, faChartLine, faServer } from '@fortawesome/free-solid-svg-icons';
import Chip from '@mui/material/Chip';
import '../assets/styles/Expertise.scss';
import { PortfolioContent, ExpertiseItem } from '../data/content';

interface ExpertiseProps {
  content: PortfolioContent['expertise'];
}

function Expertise({ content }: ExpertiseProps) {
  const getIcon = (type: ExpertiseItem['iconType']) => {
    switch (type) {
      case 'code':
        return faLaptopCode;
      case 'server':
        return faNetworkWired;
      case 'chart':
        return faChartLine;
      case 'hosting':
        return faServer;
      default:
        return faLaptopCode;
    }
  };

  return (
    <div className="skills-wrapper" id="expertise">
      <div className="skills-container">
        <h1>{content.heading}</h1>
        <p className="section-subtitle">{content.subtitle}</p>

        <div className="skills-grid">
          {content.items.map((item, idx) => (
            <div key={idx} className="skill-card">
              <div className="skill-icon-wrapper">
                <FontAwesomeIcon icon={getIcon(item.iconType)} />
              </div>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
              <div className="flex-chips">
                <span className="chip-title">{content.techStackLabel}</span>
                <div className="chip-tags">
                  {item.techStack.map((tech, techIdx) => (
                    <Chip key={techIdx} className="skill-chip" label={tech} />
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Expertise;